

import { useState, useEffect } from 'react';
import Config from '../global/env';
import axios from 'axios';
import CheckUserRight from '../utils/auth';

function useAuthorizationStatus(location: string, right: string): boolean {
    const [authorized, setAuthorized] = useState(false);

    useEffect(() => {
        async function getSessionInfo() {
            const apiURL = Config.sessionInfoURL;
            const { data } = await axios.get(apiURL);
            const isLoggedIn = data.session.loggedIn;
            const rights = data.session.info.rights;

            if (isLoggedIn) {
                const hasRight = CheckUserRight(rights, right);
                if (hasRight.read) {
                    setAuthorized(true);
                } else {
                    setAuthorized(false);
                }

            } else {
                setAuthorized(false);
            }

        }

        getSessionInfo();
    }, [location]);

    return authorized;
}

export default useAuthorizationStatus;